import * as Yup from 'yup';

export const RecordSchema = Yup.object()
                               .shape({
                                          amount: Yup.number()
                                                     .required('Required'),
                                          pricingModel: Yup.string()
                                                           .required('Required'),
                                          billingPeriod: Yup.string()
                                                            .required('Required'),
                                      });
